export enum RouteType {
    Authenticated,
    Anonymous,
    Public
}
